<h2 mat-dialog-title>{{ tituloTxt }}</h2>
<mat-dialog-content style="min-height: 100px">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <input type="hidden" formControlName="ordenCompraId" />
    <input type="hidden" formControlName="usuarioId" />

    <mat-form-field
    appearance="outline" 
      class="example-full-width"
      fxFlex="100"
      fxFlex.sm="100"
      fxFlex.md="100"
      fxFlex.lg="100"
      fxFlex.xl="100"
    >
      <mat-label>Comentario</mat-label>
      <textarea
        formControlName="comentario"
        matInput
        placeholder="Comentario sobre el deportista"
        columns="120"
        rows="6"
      >
      </textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>

  <!--   <button
  type="button"
  mat-button
  mat-flat-button
  color="primary"
  (click)="estado()"
>
  estado
</button> -->
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
